export default __webpack_public_path__ + "static/media/7C.14a56224.png";